<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <el-dialog
          v-if="isShow()"
          :title="$t('common_words.record_selected_threepoints')"
          :visible.sync="modals.read"
          width="60%"
        >
          <p>
            {{ $t('common_words.selected_record_info') }}
          </p>
          <div class="card" v-if="rowData">
            <div class="card-body" v-if="rowData">
              <table class="table">
                <tbody>
                  <tr class="shadow-sm">
                    <td>
                      <h6>
                        <strong> {{ $t('common_words.name') }}:</strong>
                      </h6>
                      {{ rowData.name }}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td>
                      <h6 class="mb-3">
                        <strong
                          >{{ $t('devices.associated_stations') }}:</strong
                        >
                      </h6>
                      <template v-if="rowData.climate_stations.length > 0">
                        <span
                          v-for="(stations, index) in rowData.climate_stations"
                          :key="`${stations.name}-${index}`"
                        >
                          <el-tag type="info">
                            {{ stations.name }}
                          </el-tag>
                        </span>
                      </template>
                      <el-tag v-else type="secondary"
                        >{{ $t('common_words.no_associated_record') }}
                      </el-tag>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer footer-date-at">
              <p class="text-muted">
                <small
                  >{{ $t('common_words.created_on') }}:
                  {{ rowData.created_at }}</small
                >
              </p>
            </div>
          </div>
        </el-dialog>
        <el-dialog :title="title" :visible.sync="modals.create">
          <form>
            <div class="row">
              <div class="col-12">
                <fg-input
                  ref="nombre"
                  type="text"
                  :label="`${$t('devices.brand_name')} *`"
                  v-model="stationMarkForm.name"
                  name="common_words.name"
                  v-validate="modelValidations.name"
                  :error="getError('common_words.name', true)"
                  placeholder="..."
                >
                </fg-input>
              </div>
            </div>
          </form>
          <span slot="footer" class="dialog-footer">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="closeModal('create')"
            >
              {{ $t('common_words.cancel') }}</button
            >&nbsp;
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="validate"
            >
              {{ $t('common_words.confirm') }}
            </button>
          </span>
        </el-dialog>
        <div class="row content-add-btn padbtn">
          <header-add
            class="col-12"
            :btnTitle="$t('devices.station_brand')"
            @openModal="openModal"
            v-if="isCreate()"
          />
        </div>
        <div v-if="isIndex()">
          <card-header
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
          >
            <template slot="addColumns">
              <table-column-badges
                prop="climate_stations[0].name"
                :label="$t('devices.associated_stations')"
                fromData="climate_stations"
                textBadge="name"
              />
            </template>
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="110"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" />
        <export-tables
          :pdf="{
            filename: `${$t('devices.station_brands')}.pdf`,
            route: 'devices/stationmarks/pdf',
          }"
          :xls="{
            filename: `${$t('devices.station_brands')}.xlsx`,
            route: 'devices/stationmarks/excel',
          }"
        />
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import Fuse from 'fuse.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import configTable from './station-marks-table';
import SweetAlert from 'src/class/Alerts';
import MixinForm from 'src/mixins/forms/mixin-form';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },
  computed: {
    ...configTable().Search,
  },
  data() {
    return {
      stationMarkForm: {
        name: null,
      },
      modelValidations: {
        name: {
          required: true,
        },
      },
      title: null,
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        create: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
    };
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      if (name == 'create') {
        this.title = i18n.t('devices.station_add_brand');
        this.$validator.reset();
        this.stationMarkForm = {
          name: null,
        };
      }
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) this.addEditStationMark();
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.title = ` ${i18n.t('devices.brand_edit')}  ${row.name}`;
      this.stationMarkForm = Object.assign({}, row);
      this.stationMarkForm.route = 'devices/stationmarks';
      this.errors.clear();
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.stationMarkForm = row;
      SweetAlert.default(
        `${i18n.t('sweet_alert.station.deactivate_brand')} "${
          this.stationMarkForm.name
        }"?`,
        null,
        i18n.t('sweet_alert.station.accept'),
        1
      ).then((result) => {
        if (result.value) this.deleteStationMark();
      });
    },

    handleActivate(index, row) {
      this.stationMarkForm = row;
      SweetAlert.default(
        `${i18n.t('sweet_alert.station.activate_brand')} 
        "${this.stationMarkForm.name}"?`,
        null,
        i18n.t('sweet_alert.station.accept'),
        1
      ).then((result) => {
        if (result.value) this.activateStationMark();
      });
    },

    activateStationMark() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.stationMarkForm.route = 'devices/stationmarks/activate';
        Axios.updateMaster(this.stationMarkForm)
          .then((response) =>
            this.modifyTable(1, this.stationMarkForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    addEditStationMark() {
      this.showHideLoading(true);
      if (this.stationMarkForm.route == 'devices/stationmarks') {
        if (this.isUpdate()) {
          Axios.updateMaster(this.stationMarkForm)
            .then((response) => {
              this.modifyTable(1, this.stationMarkForm.id, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          this.stationMarkForm.route = 'devices/stationmarks';
          Axios.saveMaster(this.stationMarkForm)
            .then((response) => {
              this.modifyTable(0, null, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    deleteStationMark() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.stationMarkForm.route = 'devices/stationmarks';
        Axios.destroyMaster(this.stationMarkForm)
          .then((response) =>
            this.modifyTable(1, this.stationMarkForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('devices/stationmarks')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('devices');
  },

  destroyed() {
    this.deselectedItemOnMenu('devices');
  },
};
</script>
<style></style>
